var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentTag,{tag:"component",staticClass:"title",class:{empty: _vm.empty},attrs:{"contenteditable":""},on:{"input":_vm.onInput}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }